var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_823_54166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.47971 5.41553L5.64219 6.25588C5.30256 6.5967 4.70499 6.60404 4.35801 6.25588L3.52045 5.41553L0.512329 8.43342C0.624302 8.4852 0.747759 8.51609 0.879009 8.51609H9.12119C9.25245 8.51609 9.37586 8.48523 9.4878 8.43344L6.47971 5.41553Z",
    fill: "#00B087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12116 1.48486H0.87897C0.74772 1.48486 0.624263 1.51576 0.512329 1.56754L3.72672 4.7926C3.72694 4.79281 3.72719 4.79285 3.72741 4.79307C3.72762 4.79328 3.72766 4.79357 3.72766 4.79357L4.77284 5.84221C4.88385 5.95322 5.11631 5.95322 5.22733 5.84221L6.27229 4.79375C6.27229 4.79375 6.27254 4.79328 6.27276 4.79307C6.27276 4.79307 6.27323 4.79281 6.27344 4.7926L9.48776 1.56752C9.37582 1.51572 9.25241 1.48486 9.12116 1.48486Z",
    fill: "#00B087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0935986 1.97705C0.0356689 2.0942 0.00012207 2.22424 0.00012207 2.36354V7.63697C0.00012207 7.77627 0.0356299 7.90631 0.0935791 8.02346L3.10692 5.00035L0.0935986 1.97705Z",
    fill: "#00B087"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90661 1.97754L6.89331 5.00088L9.90661 8.02402C9.96454 7.90688 10.0001 7.77684 10.0001 7.6375V2.36406C10.0001 2.22473 9.96454 2.09469 9.90661 1.97754Z",
    fill: "#00B087"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_823_54166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(0.00012207 0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserMail);
export default __webpack_public_path__ + "static/media/user-mail.081ea851486afa4e51334d4c33ae2ed7.svg";
export { ForwardRef as ReactComponent };